import PaymentMixin from './PaymentMixin'

export default {
    mixins: [
        PaymentMixin
    ]
}